import { render, staticRenderFns } from "./PortfolioSection.vue?vue&type=template&id=522c6463&scoped=true"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"
import style0 from "./PortfolioSection.vue?vue&type=style&index=0&id=522c6463&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522c6463",
  null
  
)

export default component.exports